import type { Me } from '../../store/auth.ts';

// Census module: org admins, census ADMINs and ENUMERATORs. Zone-only users have role === null.
export function hasCensus(u: Me): boolean {
  return u.isOrgAdmin || u.role === 'ADMIN' || u.role === 'ENUMERATOR';
}

// Zone module: any zone role, or the org admin (zone system admin).
export function hasZone(u: Me): boolean {
  return u.isOrgAdmin || !!u.zoneRole;
}

export const isSG = (u: Me): boolean => u.zoneRole === 'SECRETARY_GENERAL';
export const isStaff = (u: Me): boolean => u.zoneRole === 'STAFF';
export const isCouncillor = (u: Me): boolean => u.zoneRole === 'COUNCILLOR';
